<template>
  <div class="scenes-boxes">
    <Scene
      v-for="scene in scenes"
      :key="scene.id"
      :scene-id="scene.id"
      :scene-name="scene.name"
      :scene-description="scene.description"
      :image-url="scene.imageUrl"
    />
  </div>
</template>
<script>
import Scene from './Scene'
export default {
  components: { Scene },
  props: {
    scenes: {
      type: Array,
      required: true
    }
  }
}
</script>
